var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAct(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.23148 21.666H1.8714C1.61065 21.6665 1.3541 21.612 1.12616 21.5078C0.898223 21.4037 0.706485 21.2532 0.569197 21.0709C0.425806 20.8921 0.344611 20.6845 0.334409 20.4705C0.324207 20.2564 0.385387 20.0442 0.511321 19.8568L1.4084 18.357C1.53395 18.1488 1.72795 17.9738 1.96837 17.8517C2.20878 17.7297 2.48598 17.6656 2.76848 17.6666H4.12856C4.38931 17.6662 4.64586 17.7206 4.8738 17.8248C5.10174 17.929 5.29347 18.0794 5.43076 18.2618C5.57415 18.4405 5.65535 18.6482 5.66555 18.8622C5.67575 19.0762 5.61457 19.2884 5.48864 19.4759L4.59156 20.9756C4.47234 21.1879 4.27978 21.3665 4.0379 21.4893C3.79602 21.6121 3.51555 21.6735 3.23148 21.666Z",
    fill: "url(#paint0_linear_2482_23)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5267 19.699L12.2559 1.0837C12.1432 0.858126 11.9703 0.668498 11.7565 0.535991C11.5428 0.403484 11.2966 0.333313 11.0455 0.333313C10.7944 0.333313 10.5483 0.403484 10.3346 0.535991C10.1208 0.668498 9.94793 0.858126 9.83519 1.0837L3.13959 14.5467C3.03966 14.7542 2.99209 14.9831 3.00107 15.2134C3.01006 15.4437 3.07532 15.6682 3.1911 15.8672C3.30841 16.0584 3.47086 16.2175 3.66404 16.3304C3.85721 16.4433 4.07513 16.5065 4.29844 16.5144H12.6422C12.8742 16.5149 13.1025 16.4557 13.3054 16.3424C13.5082 16.2291 13.6789 16.0655 13.801 15.8672C13.9286 15.6727 14.0009 15.4469 14.01 15.2142C14.0191 14.9814 13.9646 14.7506 13.8525 14.5467L13.3117 13.4593C13.2 13.2329 13.0274 13.0426 12.8134 12.9098C12.5995 12.7771 12.3528 12.7074 12.1014 12.7085H8.3158L11.0713 7.16796L17.8957 20.9158C18.0074 21.1422 18.18 21.3326 18.394 21.4653C18.6079 21.598 18.8546 21.6678 19.106 21.6666H20.3164C20.5484 21.6671 20.7767 21.6079 20.9796 21.4946C21.1824 21.3813 21.3531 21.2177 21.4752 21.0194C21.5912 20.8205 21.6566 20.596 21.6656 20.3657C21.6746 20.1353 21.6269 19.9063 21.5267 19.699Z",
    fill: "url(#paint1_linear_2482_23)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0454 4.33331C18.7658 4.33412 18.4928 4.41648 18.2615 4.5698C18.0303 4.72312 17.8513 4.94038 17.7478 5.19365L13.8418 14.7333C13.9476 14.9307 13.9974 15.1521 13.986 15.3745C13.9746 15.597 13.9024 15.8124 13.777 15.9985C13.6188 16.2461 13.3818 16.4363 13.1022 16.54L11 21.6666H13.6212C13.9005 21.6642 14.1727 21.5811 14.4037 21.428C14.6346 21.2749 14.8139 21.0586 14.9189 20.8063L21.6667 4.33331H19.0454Z",
    fill: "url(#paint2_linear_2482_23)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2482_23",
    x1: 0.355056,
    y1: 19.6663,
    x2: 5.68542,
    y2: 19.6663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B42AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00276E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2482_23",
    x1: 3.00053,
    y1: 10.9998,
    x2: 21.6658,
    y2: 10.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B42AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00276E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2482_23",
    x1: 11,
    y1: 13,
    x2: 21.6667,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF536C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA10A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAct);
export default __webpack_public_path__ + "static/media/ACT.a09919c7a3cec95ecaad85b802d1b4fd.svg";
export { ForwardRef as ReactComponent };